import React, { useState } from 'react'
import { Box, Button, Checkbox, FormControlLabel, Grid } from '@material-ui/core'
import HelpIcon from '@material-ui/icons/Help'
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank'
import CheckBoxIcon from '@material-ui/icons/CheckBox'

import { useFiltersModalStyles } from 'core/table/table-hooks'

export interface GroupOverviewFilterModalProps {
  showArchivedGroups: boolean
  setShowArchivedGroups: (value: boolean) => void
  onClose: (...args: any) => void
}

//TODO: This is copied from src/core/table/components/NewFiltersModal.tsx
//
//   Need to integrate the binary filters into the getOperations flow so
//   we don't need to work around it
const GroupOverviewFilterModal = (props: GroupOverviewFilterModalProps) => {
  const { showArchivedGroups, setShowArchivedGroups, onClose } = props

  const classes = useFiltersModalStyles()

  const [checked, setChecked] = useState(showArchivedGroups) //TODO use initial value

  const clearFilters = () => {
    setChecked(false)
  }

  const applyFilters = () => {
    setShowArchivedGroups(checked)
    onClose()
  }

  return (
    <Box width={650} pb={1} pl={2} pr={2} style={{ backgroundColor: '#F8FAFF', maxHeight: '100%' }}>
      <p id="filter-title" className={classes.header}>
        Add and Remove Filters{' '}
        <a
          href="https://support.civicchamps.com/how-to-filter-your-volunteer-data-for-reporting"
          target="_blank"
          rel="noopener noreferrer"
        >
          <HelpIcon className={classes.helpIcon} />
        </a>
      </p>
      <Grid container direction="column">
        <FormControlLabel
          classes={{ label: classes.checkboxLabel }}
          control={
            <Checkbox
              classes={{ root: classes.checkboxRoot }}
              icon={<CheckBoxOutlineBlankIcon className={classes.checkbox} fontSize="small" />}
              checkedIcon={<CheckBoxIcon className={classes.checkboxChecked} fontSize="small" />}
              checked={checked}
              onChange={(e, v) => setChecked(v)}
            />
          }
          label="Show Archived Groups"
        />
      </Grid>
      <Box display="flex" mt={1} mb={1}>
        <Button onClick={clearFilters} className={classes.actionButton}>
          Clear All Filters
        </Button>
        <Box ml="auto" display="inline-block">
          <Button className={classes.actionButton} onClick={onClose}>
            Cancel
          </Button>

          <Box ml={1} display="inline-block">
            <Button className={classes.actionButton} onClick={applyFilters}>
              Apply
            </Button>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default GroupOverviewFilterModal
